const COLORS = {
  'black': '#000000',
  'white': '#FFFFFF',
  'red': '#E60000',
  'blue': '#0066FF',
  'electric blue': '#0080FF',
  'neon green': '#39FF14',
  'green': '#00CC44',
  'orange': '#FF6600',
  'neon orange': '#FF5F1F',
  'yellow': '#FFD700',
  'neon yellow': '#DFFF00',
  'purple': '#8B00FF',
  'pink': '#FF1493',
  'hot pink': '#FF0080',
  'neon pink': '#FF10F0',
  'grey': '#808080',
  'gray': '#808080',
  'silver': '#C0C0C0',
  'teal': '#00CED1',
  'navy': '#001F5C',
  'gold': '#FFD700',
  'bronze': '#CD7F32',
  'copper': '#B87333',
  'matte black': '#1A1A1A',
  'gloss black': '#0A0A0A',
  'sand': '#C2B280',
  'charcoal': '#36454F',
  'lime': '#32CD32',
  'turquoise': '#00E5CC',
  'coral': '#FF6F61',
  'candy red': '#E40046',
  'zombie green': '#00FF80',
  'high temp bronze': '#c08b5c',
  'high temp. bronze': '#c08b5c',
  'o.d. green': '#6b6930',
  'od green': '#6b6930',
  'highland green': '#3d5429',
  'tungsten': '#5a5a5a',
  'glacier black': '#1a1a1a',
  'raw steel': '#71797E',
  'blue titanium': '#3a5a78',
  // Prismatic Powders "closest match" colours used across the brand colour tables.
  'gloss white': '#F7F7F5',
  'box white': '#F2F2EE',
  'dirty white': '#E4E1D6',
  'natural cotton': '#E6DFCB',
  'semi gloss black': '#141414',
  'black jack': '#0B0B0B',
  'manta green': '#008F5A',
  'dunbar teal': '#0E6E63',
  'jamaican teal': '#009B8E',
  'orange madness': '#F04A1E',
  'hot orange': '#F3560E',
  'juju orange': '#E8571C',
  'ktm orange ii': '#F45B1B',
  'hot rod orange': '#E8531A',
  'ral 1028': '#F39F18',
  'racer red': '#C41230',
  'vampire red': '#9E1B1B',
  'illusion ruby': '#7A0E1C',
  'frosted grape': '#5A2A6B',
  'candy purple': '#5B1E8C',
  'infused purple': '#3B2A5A',
  'savannah mist': '#8FA6C0',
  'illusion lite blue': '#4FA8E0',
  'oh so blue': '#1E7FD4',
  'sparks blue': '#5E7C99',
  'voodoo blue': '#0E4FA8',
  'octane blue': '#1B3A8C',
  'illusion royal': '#0B2E7A',
  'neutron star': '#232A38',
  'lightning opal': '#6E6A82',
  'urban stealth': '#3A3F44',
  'kingsport grey': '#6E7175',
  'arcene silver': '#B8BCC0',
  'lemon peel': '#F2D21C',
  'maverick yellow': '#F0C81E'
};

function applySwatches() {
  document.querySelectorAll('.product-form__input--pill').forEach(fieldset => {
    const legend = fieldset.querySelector('.form__label');
    if (!legend) return;
    const name = legend.childNodes[0]?.textContent?.trim();
    if (name !== 'Color' && name !== 'Colour') return;
    fieldset.setAttribute('data-option-name', 'Color');
    fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
      const val = input.value.trim().toLowerCase();
      const label = input.nextElementSibling;
      if (!label) return;
      const color = COLORS[val];
      if (!color) {
        label.style.setProperty('background', '#CCCCCC', 'important');
      } else if (color.includes('gradient')) {
        label.style.setProperty('background', color, 'important');
      } else {
        label.style.setProperty('background-color', color, 'important');
      }
      label.style.setProperty('font-size', '0', 'important');
      label.style.setProperty('border-radius', '50%', 'important');
      label.style.setProperty('width', '3.6rem', 'important');
      label.style.setProperty('height', '3.6rem', 'important');
      label.style.setProperty('min-width', '0', 'important');
      label.style.setProperty('padding', '0', 'important');
      label.style.setProperty('overflow', 'hidden', 'important');
      if (val === 'white') {
        label.style.setProperty('border-color', 'rgba(255,255,255,0.4)', 'important');
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applySwatches);
} else {
  applySwatches();
}

new MutationObserver(applySwatches).observe(document.body, { childList: true, subtree: true });
